var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c("h4", { staticClass: "modal-title" }, [_vm._v(_vm._s(_vm.title))]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "modal-body" }, [
      _c("div", { staticClass: "md-layout batch-import-template" }, [
        _c(
          "div",
          { staticClass: "md-layout-item md-size-90" },
          [
            _c(
              "form-group",
              {
                attrs: {
                  name: "mappingtemplate",
                  label: "Select Import Template",
                },
              },
              [
                _c(
                  "md-select",
                  {
                    model: {
                      value: _vm.selectedTemplateName,
                      callback: function ($$v) {
                        _vm.selectedTemplateName = $$v
                      },
                      expression: "selectedTemplateName",
                    },
                  },
                  _vm._l(_vm.templateNameList, function (templateName) {
                    return _c(
                      "md-option",
                      { key: templateName, attrs: { value: templateName } },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(templateName) +
                            "\n                        "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "md-layout-item md-size-10" },
          [
            _c(
              "md-button",
              {
                staticClass:
                  "md-primary md-just-icon md-round pull-right download-btn",
                attrs: { title: "Download Sample Template" },
                on: { click: _vm.downloadSampleTemplate },
              },
              [_c("md-icon", [_vm._v("get_app")])],
              1
            ),
          ],
          1
        ),
      ]),
      _c("input", {
        ref: "fileInput",
        staticStyle: { display: "none" },
        attrs: { "data-testid": "upload-file", type: "file" },
        on: { change: _vm.onFileSelected },
      }),
      _c(
        "button",
        {
          staticClass: "custom-btn",
          on: {
            click: function ($event) {
              return _vm.$refs.fileInput.click()
            },
          },
        },
        [_vm._v("\n            Select File...\n        ")]
      ),
      _c(
        "div",
        { staticClass: "error-message-container" },
        [
          _c("batch-upload-error-message", {
            attrs: {
              content: _vm.errorMessages,
              "has-error-message": _vm.hasError,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }